<template>
  <div class="management_box" v-show="managementVisible">
    <div class="management">
      <management-title slot="management_name" class="management_title">
        <div>
          <span>分组管理器</span>
          <img :src="close" alt="关闭" @click="managementVisibleFun()" />
        </div>
      </management-title>
      <div class="tree">
        <cw-tree :data="data"></cw-tree>
        <!-- <management-tree-group
          v-for="(group, index) in data"
          :key="index"
          :group="group"
          v-model="checkedAll"
          :checked="checkedAll"
          @groupChange="groupChange(group, index)"
          @checkChange="checkChange($event, group, index)"
        >
          <management-tree-list
            slot="tree-list"
            v-for="(list, index) in checkList"
            :key="index"
            :list="list"
            :height="
              group.id == isHeightNum && group.account_list.length != 0
                ? 'auto'
                : '0px'
            "
          >
          </management-tree-list>
        </management-tree-group> -->
      </div>
      <div class="handle">
        <div class="addGroup">
          <img :src="handelAdd" /><span>添加分组</span>
        </div>
        <div class="handleGroup">
          <span><img :src="HandleTop" /><span>置顶</span></span>
          <span><img :src="HandleEdit" /><span>编辑</span></span>
          <span><img :src="HandleDelete" /><span>删除</span></span>
        </div>
      </div>
      <div class="determine">
        <span>取消</span>
        <span>确定</span>
      </div>
    </div>
  </div>
</template>

<script>
import managementTitle from "@/components/groupManagement/ManagementTitle.vue";
import managementTree from "@/components/groupManagement/ManagementTree.vue";
import managementTreeGroup from "@/components/groupManagement/ManagementTreeGroup.vue";
import managementTreeList from "@/components/groupManagement/ManagementTreeList.vue";
import cwTree from "@/components/groupManagement/CwTree.vue"
export default {
  name: "Management",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      HandleDelete: require("@/common/assets/HandleDelete.png"),
      HandleTop: require("@/common/assets/HandleTop.png"),
      HandleEdit: require("@/common/assets/HandleEdit.png"),
      handelAdd: require("@/common/assets/handelAdd.png"),
      isHeightNum: 0,
      clickIndex: 0,
      data: [],
      checkedAll: false,
      checkList: [],
    };
  },
  created() {},
  components: {
    managementTitle,
    managementTree,
    managementTreeGroup,
    managementTreeList,
    cwTree,
  },
  methods: {
    managementVisibleFun() {
      this.$emit("managementVisibleFun", this.managementVisible);
    },
    groupChange(item, index) {
      this.isHeightNum = item.id;
    },
    checkChange(e, item, index) {
      // this.isHeightNum == item.id;
      if (e.target.checked) {
        item.account_list.forEach((items) => {
          items.checked = true;
        });
        if (this.isHeightNum == item.id) {
        }
      } else {
        item.account_list.forEach((items) => {
          items.checked = e.target.checked;
        });
        if (this.isHeightNum == item.id) {
          this.checkList = item.account_list
        }
      }
      // console.log(item);
    },
  },
  props: {
    managementVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    managementVisible(data) {
      this.managementVisible = data;
      // console.log(this.managementVisible);
    },
    data(val) {
      this.data = val;
      // console.log(val)
    },
  },
};
</script>

<style lang="less" scoped>
.management_box {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.589);
  z-index: 1000;
  .management {
    width: 440px;
    height: 580px;
    background-color: #fff;
    margin-left: calc(100% / 2 - 400px / 2);
    margin-top: 200px;
    border-radius: 16px;
    .management_title {
      width: 100%;
      border: solid 1px #f1f1f1;
      border-top: none;
      border-right: none;
      border-left: none;
      height: 60px;
      box-sizing: border-box;
      position: relative;
      span {
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        line-height: 60px;
        display: inline-block;
      }
      img {
        position: absolute;
        right: 14px;
        top: 14px;
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
    .tree {
      width: 100%;
      height: 340px;
      overflow-x: hidden;
      // border: solid 1px green;
      .management_tree::after {
        content: "";
        display: inline-block;
        clear: both;
      }
    }
    .handle {
      color: #20a0ff;
      width: 94%;
      margin-left: calc(100% / 2 - 94% / 2);
      height: 30px;
      .addGroup {
        box-sizing: border-box;
        border: solid 1px #999;
        border-left: none;
        border-right: none;
        border-top: none;
        width: 100%;
        // margin-left: calc(100%/2 - 94%/2);
        height: 50px;
        line-height: 50px;
        float: left;
      }
      .addGroup > img {
        float: left;
        width: 20px;
        height: 20px;
        margin-top: calc(50px / 2 - 20px / 2);
        margin-left: 10px;
      }
      .addGroup > span {
        float: left;
        margin-left: 10px;
        color: #999;
      }
      .handleGroup {
        width: 100%;
        // border: solid 1px;
        float: left;
        margin-top: 10px;
      }
      .handleGroup > span::after {
        content: "";
        clear: both;
        display: inline-block;
      }
      .handleGroup > span {
        width: 90px;
        height: 20px;
        display: inline-block;
        cursor: pointer;
        // border: solid 1px;
        img {
          float: left;
          width: 20px;
          height: 20px;
          display: inline-block;
        }
        span {
          float: left;
          line-height: 20px;
          margin-left: 4px;
          font-size: 16px;
        }
      }
    }
    .determine {
      width: 100%;
      height: 60px;
      margin-top: 20px;
      display: inline-block;
      // border: solid 1px;
      span {
        float: right;
        margin-right: 10px;
        width: 60px;
        height: 30px;
        margin-top: 14px;
        text-align: center;
        line-height: 34px;
        display: inline-block;
        // border: solid 1px;
      }
      span:first-child {
        background-color: #20a0ff;
        border-radius: 4px;
        color: #fff;
      }
      span:last-child {
        background-color: #999;
        border-radius: 4px;
        color: #3e3e3e;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/groupManagement/Management.vue